import { createSlice } from "@reduxjs/toolkit";

import { fetchCandidates, updateCandidateStatus } from "./candidates.thunk";

import { CandidateListItem, Pagination } from "../types";

interface CandidateState {
  candidates: CandidateListItem[];
  pagination: Pagination | null;
  loading: boolean;
  error: string | null;
}

const initialState: CandidateState = {
  candidates: [],
  pagination: null,
  loading: false,
  error: null,
};

const candidatesSlice = createSlice({
  name: "candidates",

  initialState,

  reducers: {},

  extraReducers: (builder) => {
    builder

      /*
      |--------------------------------------------------------------------------
      | Fetch Candidates
      |--------------------------------------------------------------------------
      */

      .addCase(fetchCandidates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchCandidates.fulfilled, (state, action) => {
        state.loading = false;

        state.candidates = action.payload.data;

        state.pagination = action.payload.pagination;
      })

      .addCase(fetchCandidates.rejected, (state, action) => {
        state.loading = false;

        state.error = action.payload as string;
      })

      /*
      |--------------------------------------------------------------------------
      | Update Candidate Status
      |--------------------------------------------------------------------------
      */

      .addCase(updateCandidateStatus.pending, (state) => {
        state.error = null;
      })

      .addCase(updateCandidateStatus.fulfilled, (state, action) => {
        const updatedApplicationId = action.payload?.data?.applicationId;

        const updatedHistory = action.payload?.data?.statusHistory;

        if (updatedApplicationId && updatedHistory) {
          const candidate = state.candidates.find(
            (item) => item.id === updatedApplicationId
          );

          if (candidate) {
            candidate.status = updatedHistory as CandidateListItem["status"];
          }
        }
      })

      .addCase(updateCandidateStatus.rejected, (state, action) => {
        state.error = action.payload as string;
      });
  },
});

export default candidatesSlice.reducer;